import React from "react";
import { Redirect, Route } from "react-router-dom";

function ProtectedRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("loggedInEmail");
  // console.log("this", isAuthenticated);

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login",
               state: {
               IndirectAccess: true,
               from: props.location.pathname 
              } 
            }}
          />
        )
      }
    />
  );
}

export default ProtectedRoute;
